// Export all stores
export { useAuthStore } from './auth.js'
export { useCartStore } from './cart.js'
export { useProductsStore } from './products.js'
export { useCategoriesStore } from './categories.js'
export { useOrdersStore } from './orders.js'
export { useNotificationsStore } from './notifications.js'
export { useUIStore } from './ui.js'

// Store utilities
export const initializeStores = async () => {
  try {
    // Import stores dynamically to avoid circular dependency issues
    const { useAuthStore } = await import('./auth.js')
    const { useCartStore } = await import('./cart.js')
    
    // Initialize auth store first to restore authentication state
    const authStore = useAuthStore()
    const authRestored = authStore.initAuth()
    
    console.log('Auth initialization:', authRestored ? 'User authenticated' : 'Guest user')
    
    // Initialize session for cart (only for guests)
    const { initializeSession } = await import('../api/index.js')
    if (initializeSession && !authStore.isAuthenticated) {
      initializeSession()
    }
    
    // Initialize cart store on app load so cart is ready after page reload
    const cartStore = useCartStore()
    await cartStore.initCart()
    
    console.log('Session and cart initialized successfully')
  } catch (error) {
    console.error('Error initializing stores:', error)
  }
}

// Initialize individual stores when needed
export const initializeUIStore = async () => {
  try {
    const { useUIStore } = await import('./ui.js')
    const uiStore = useUIStore()
    if (uiStore && uiStore.initializeUI) {
      uiStore.initializeUI()
    }
  } catch (error) {
    console.error('Error initializing UI store:', error)
  }
}

export const initializeAuthStore = async () => {
  try {
    const { useAuthStore } = await import('./auth.js')
    const authStore = useAuthStore()
    if (authStore && authStore.initAuth) {
      authStore.initAuth()
    }
  } catch (error) {
    console.error('Error initializing Auth store:', error)
  }
}

export const resetAllStores = async () => {
  try {
    const { useAuthStore } = await import('./auth.js')
    const { useCartStore } = await import('./cart.js')
    const { useProductsStore } = await import('./products.js')
    const { useCategoriesStore } = await import('./categories.js')
    const { useOrdersStore } = await import('./orders.js')
    const { useNotificationsStore } = await import('./notifications.js')
    
    const authStore = useAuthStore()
    const cartStore = useCartStore()
    const productsStore = useProductsStore()
    const categoriesStore = useCategoriesStore()
    const ordersStore = useOrdersStore()
    const notificationsStore = useNotificationsStore()
    
    // Clear all stores
    authStore.clearAuth()
    cartStore.clearCart()
    productsStore.clearProducts()
    categoriesStore.clearCategories()
    ordersStore.clearOrders()
    notificationsStore.clearAllNotifications()
  } catch (error) {
    console.error('Error resetting stores:', error)
  }
}
